import React, { useEffect, useRef, useState } from 'react';
import { ArrowRightIcon, PlayIcon } from 'lucide-react';
import { videoWalkthroughs } from '../../data/videoWalkthroughs';
export function VideoSection() {
  const [activeId, setActiveId] = useState(videoWalkthroughs[0].id);
  const videoRef = useRef<HTMLVideoElement>(null);
  const active = videoWalkthroughs.find(video => video.id === activeId) || videoWalkthroughs[0];
  useEffect(() => {
    const element = videoRef.current;
    if (!element) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          void element.play().catch(() => undefined);
        } else {
          element.pause();
        }
      });
    }, {
      threshold: 0.35
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [activeId]);
  return <section id="walkthroughs" className="navy-texture scroll-mt-6 border-y border-[#031849] text-white" data-id="element-143" data-mp="2yfpwllqcgo96">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-144" data-mp="1enuli14vuymx">
        <div className="max-w-2xl" data-id="element-145" data-mp="1jmywmxbdb6fw">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#4BE4FF]" data-id="element-146" data-mp="1jm5vcbv6h955">
            Product walkthroughs
          </p>
          <h2 className="font-display mt-3 text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-147" data-mp="1tdk3f8173h9w">
            See Credit Manager in action.
          </h2>
        </div>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1.4fr_0.6fr] lg:gap-12" data-id="element-148" data-mp="vs4hy9haxu6x">
          <div data-id="element-149" data-mp="10qz1jdn3fms3">
            <div className="overflow-hidden border border-[#A6B6F8]/30 bg-[#031849]" data-id="element-150" data-mp="10qpjcc8aijwy">
              <video key={active.id} ref={videoRef} src={encodeURI(active.src)} controls autoPlay muted preload="auto" playsInline className="block aspect-video h-auto w-full" data-id="element-151" data-mp="15q28x4qjq538">
                Your browser does not support embedded video.
              </video>
            </div>
            <p className="mt-3 text-xs text-[#A6B6F8]" data-id="element-152" data-mp="h1em4wpwtu36">
              Plays muted automatically — use the controls to turn sound on.
            </p>
            <h3 className="font-display mt-5 text-lg font-bold uppercase tracking-[0.05em]" data-id="element-153" data-mp="uzv11axxeqwe">
              {active.title}
            </h3>
            <p className="mt-2.5 max-w-2xl text-base leading-7 text-[#A6B6F8]" data-id="element-154" data-mp="2bpfilz1sxvi">
              {active.description}
            </p>
            <a href="/signup" className="font-display mt-7 inline-flex items-center gap-2 bg-[#4BE4FF] px-9 py-4 text-[13px] font-bold uppercase tracking-[0.13em] text-[#041F60] transition-colors duration-150 hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-155" data-mp="3ugt01hjrj5uu">
              Start your free trial{' '}
              <ArrowRightIcon size={16} aria-hidden="true" data-id="element-156" data-mp="3ar0t5lc7owvo" />
            </a>
          </div>

          <div data-id="element-157" data-mp="1q8ybkohe2ppv">
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-[#4BE4FF]" data-id="element-158" data-mp="1q86o60xy3yao">
              In this series
            </h3>
            <ul className="mt-4 border-t border-[#A6B6F8]/30" data-id="element-159" data-mp="1h91vhb92ez6f">
              {videoWalkthroughs.map(video => {
              const isActive = video.id === active.id;
              return <li key={video.id} className="border-b border-[#A6B6F8]/30" data-id="element-160" data-mp="29xqwzbe196ip">
                    <button type="button" onClick={() => setActiveId(video.id)} aria-current={isActive} className={`flex w-full items-center gap-3 px-3 py-4 text-left transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-[#4BE4FF] ${isActive ? 'bg-white/10' : 'hover:bg-white/5 focus:bg-white/5'}`} data-id="element-161" data-mp="29vmhrxaool34">
                      <span aria-hidden="true" className={`grid h-8 w-8 shrink-0 place-items-center ${isActive ? 'bg-[#4BE4FF] text-[#041F60]' : 'border border-[#A6B6F8]/50 text-[#A6B6F8]'}`} data-id="element-162" data-mp="18svuqjv2z96d">
                        <PlayIcon size={14} data-id="element-163" data-mp="uzwdacbqn4w6" />
                      </span>
                      <span className={`text-sm leading-6 ${isActive ? 'font-bold text-white' : 'font-semibold text-[#A6B6F8]'}`} data-id="element-164" data-mp="1rrgic1xrjwf9">
                        {video.title}
                      </span>
                    </button>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}